// extracted by mini-css-extract-plugin
export default {"headerDashboard":"styles_headerDashboard__fZRZs","avatar":"styles_avatar__seuhq"};